<template>
  <div class="match-list-section">
    <img
      class="section-top"
      src="@/assets/imgs/act/wc2026/section-top.png"
      alt="section-title-icon"
    />

    <!-- 日期筛选 -->
    <div class="date-select-wrap" v-if="state.dateList.length > 0">
      <span class="date-select-label">{{ $t("wc2026.bet.selectDate") }}</span>
      <div class="date-select-box">
        <select
          class="date-select"
          v-model="state.selectedDate"
          @change="selectDate(state.selectedDate)"
        >
          <option v-for="date in state.dateList" :key="date" :value="date">
            {{ formatDateTab(date) }}
          </option>
        </select>
        <div class="date-select-arrow">▼</div>
      </div>
    </div>

    <!-- 赛程列表 -->
    <div class="matches" v-if="state.matchList.length > 0">
      <div
        class="match-card green-bg"
        v-for="match in state.matchList"
        :key="match.matchId"
      >
        <!-- 顶部：时间 + 结果标签 -->
        <div class="match-top-row flex">
          <div class="footer-box-icon"></div>
          <div class="result-text">
            {{ getMatchResultText(match) }}
          </div>
        </div>

        <!-- 队伍对战区 -->
        <div class="match-teams">
          <!-- A队（主队） -->
          <div
            class="team"
            :class="getTeamClass(match, 1)"
            @click="handleSelectTeam(match, 1)"
          >
            <img :src="match.teamAFlag" class="team-flag" alt="" />

            <div class="team-name">{{ match.teamAName }}</div>
          </div>
          <div class="vs-block-wrap">
            <div class="vs-block"></div>
            <div class="match-time-text">{{
              formatMatchTime(match.matchTime)
            }}</div>
          </div>
          <!-- B队（客队） -->
          <div
            class="team"
            :class="getTeamClass(match, 2)"
            @click="handleSelectTeam(match, 2)"
          >
            <img
              v-if="match.teamBFlag"
              :src="match.teamBFlag"
              class="team-flag"
              alt=""
            />
            <div class="team-name">{{ match.teamBName }}</div>
          </div>
        </div>

        <!-- 底部操作区 -->
        <div class="match-action yellow-bg flex-center">
          <div
            @click="handleSubmitCheer(match, 1)"
            class="cheer-btn-wrap flex-center btn"
            :class="{ cheered: match.userCheerTeam === 1 }"
          >
            <div class="cheered-icon"></div>
            <div class="cheer-btn btn">
              {{ match.teamAName }}
            </div>
          </div>
          <div
            @click="handleSubmitCheer(match, 2)"
            class="cheer-btn-wrap flex-center btn"
            :class="{ cheered: match.userCheerTeam === 2 }"
          >
            <div class="cheered-icon"></div>
            <div class="cheer-btn">
              {{ match.teamBName }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-tip" v-else-if="!state.loading">
      {{ $t("wc2026.bet.noMatches") }}
    </div>
  </div>

  <LoginDialog
    v-model="state.showLoginDialog"
  />
  <ConfirmDialog
    v-model="confirmDialog.visible"
    :content="confirmDialog.content"
    @confirm="doPlaceCheer"
  />
</template>

<script setup>
/* eslint-disable */
import { reactive, defineProps, defineEmits, onMounted, computed, watch } from "vue";


import { useI18n } from "vue-i18n";
import dayjs from "dayjs";
import WcApi from "@/config/wcActApi";
import { toastService } from "@/utils/toastService";
import ConfirmDialog from "../ConfirmDialog/index.vue";
import { useStore } from "vuex";
import { formatInTimezone, formatDateTabInTimezone } from "../../utils/time";
import { useLog } from "@/composables/useActLog";
import LoginDialog from "../LoginDialog/index.vue";
const log = useLog();
const store = useStore();
const activityInfo = computed(() => store.state.wcAct.activityInfo || {});

const props = defineProps({
  isBetEnd: { type: Boolean, default: false },
});

const emit = defineEmits(["showRule", "showRecord", "cheerSuccess"]);
const { t, locale } = useI18n();

const state = reactive({
  loading: false,
  dateList: [],
  selectedDate: "",
  matchList: [],
  showLoginDialog: false,
});

const confirmDialog = reactive({
  visible: false,
  match: null,
  content: "",
});

const formatDateTab = (dateStr) => {
  return formatDateTabInTimezone(dateStr, locale.value);
};

const formatMatchTime = (ts) => {
  return formatInTimezone(ts, locale.value, "HH:mm");
};

const getMatchResultText = (match) => {
  if(match.status === 2 && !match.result) {
    return t("wc2026.bet.matchResult.running");
  }

  if (match.result === 0) {
    if (match.userCheerTeam) {
      return t("wc2026.bet.matchResult.cheered");
    }
    return t("wc2026.bet.matchResult.pending");
  }

  if (match.result === 3) return t("wc2026.bet.matchResult.daping");
  const teamName = match.result === 1 ? match.teamAName : match.teamBName;
  return t("wc2026.bet.matchResult.win").replace("_team", teamName);
};

const canCheer = (match) => {
  const result =
    match.userCheerTeam === 0 &&
    match.result === 0 &&
    activityInfo.value.availableCheerCount > 0;

  return result;
};

const getTeamClass = (match, team) => {
  return {
    selected: match._selectedTeam === team,
    cheered: match.userCheerTeam === team,
    "cheer-win": match.userCheerTeam === team && match.userCheerWin,
    "cheer-lose":
      match.userCheerTeam === team &&
      !match.userCheerWin &&
      match.userCheerSettle > 0,
    disabled: !canCheer(match) && match.userCheerTeam !== team,
  };
};

const handleSubmitCheer = (match, team) => {
  // if (!match._selectedTeam) {
  //   toastService.showSmall(t('wc2026.bet.error.noSelection'))
  //   return
  // }

  if (!store.state.actUserInfo?.token) {
    state.showLoginDialog = true;
    return;
  }

  if (activityInfo.value.availableCheerCount <= 0) {
    toastService.show(t("wc2026.error.code1106"));
    return;
  }
  if (!canCheer(match)) {
    return;
  }
  match._selectedTeam = team;
  const teamName = team === 1 ? match.teamAName : match.teamBName;
  confirmDialog.match = match;
  confirmDialog.content = t("wc2026.bet.confirm.content") + teamName;
  confirmDialog.visible = true;
};

const doPlaceCheer = async () => {
  const match = confirmDialog.match;
  if (!match) return;
  try {
    await WcApi.placeCheer({
      matchId: match.matchId,
      cheerTeam: match._selectedTeam,
    });
    const teamId = match._selectedTeam === 1 ? match.teamAId : match.teamBId;
    log.track("act_worldcup_support", {
      v1: teamId || (match._selectedTeam === 1 ? match.teamAName : match.teamBName),
    });
    match.userCheerTeam = match._selectedTeam;
    match._selectedTeam = 0;
    confirmDialog.visible = false;
    confirmDialog.match = null;
    toastService.show(t("wc2026.bet.cheerSuccess"));
    emit("cheerSuccess");
  } catch (e) {
    console.error(e);
  }
};

const getSettleClass = (match) => {
  if (match.userCheerSettle === 0) return "pending";
  if (match.userCheerSettle === 1) return "win";
  if (match.userCheerSettle === 2) return "lose";
  if (match.userCheerSettle === 3) return "cancelled";
  return "";
};

const getSettleText = (match) => {
  if (match.userCheerSettle === 0) return t("wc2026.bet.settle.pending");
  if (match.userCheerSettle === 1) return t("wc2026.bet.settle.win");
  if (match.userCheerSettle === 2) return t("wc2026.bet.settle.lose");
  if (match.userCheerSettle === 3) return t("wc2026.bet.settle.cancelled");
  return "";
};

const selectDate = async (date) => {
  state.selectedDate = date;
  await loadMatches(date);
};

const loadMatches = async (date) => {
  state.loading = true;
  try {
    const isLoggedIn = !!store.state.actUserInfo?.token;
    const fetchFn = isLoggedIn ? WcApi.getMatchList : WcApi.getMatchListCommon;
    const res = await fetchFn({ date: date || "" });
    state.dateList = res.dateList || [];
    if (!state.selectedDate && res.dateList && res.dateList.length > 0) {
      state.selectedDate = res.currentDate;
    }
    state.matchList = (res.matchList || []).map((m) => ({
      ...m,
      _selectedTeam: 0,
    }));
  } catch (e) {
    console.error(e);
  } finally {
    state.loading = false;
  }
};

watch(()=>store.state.actUserInfo, () => {
  loadMatches("");
}, { immediate: true, deep: true });
</script>

<style lang="less" scoped>
@import "../shared.less";

// ============================================================
// MatchList - 赛程列表
// 设计稿 750px，内容区域 702px（两侧各 24px padding）
// ============================================================

.match-list-section {
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    .section-title {
      font-size: 34px;
      font-weight: bold;
      color: #fff;
      margin: 0;
    }

    .header-actions {
      display: flex;
      gap: 12px;
    }
  }
}

.wc-btn.small {
  padding: 10px 20px;
  font-size: 22px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }
}

// ============================================================
// 日期下拉选择
// ============================================================
.date-select-wrap {
  display: flex;
  align-items: center;
  max-width: 750px;
  padding-left: 38px;
  margin-bottom: 48px;
  margin-top: 16px;
  gap: 16px;

  .date-select-label {
    font-size: 26px;
    font-weight: bold;
    color: #1b0926;

  }

  .date-select-box {
    position: relative;
    flex-shrink: 0;
    width: 200px;

    .date-select {
      width: 100%;
      padding: 10px 70px 10px 20px;
      background: #4caf50;
      border: none;
      border-radius: 6px;
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      appearance: none;
      -webkit-appearance: none;
      cursor: pointer;
      outline: none;
      box-sizing: border-box;

      option {
        background: #2e7d32;
        color: #fff;
        font-weight: normal;
      }
    }

    .date-select-arrow {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.15);
      border-radius: 0 6px 6px 0;
      color: #fff;
      font-size: 20px;
      pointer-events: none;
    }
  }
}

// ============================================================
// 赛程卡片列表
// ============================================================
.matches {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.match-card {
  padding: 60px 38px 40px 38px;
  position: relative;
  margin-bottom: 78px;

  .match-top-row {
    position: absolute;
    top: -43px;
    right: 0;
    width: 205px;
    height: 86px;
    background-image: url("~@/assets/imgs/act/wc2026/match/tag-bg.png");
    align-items: center;
    .footer-box-icon {
      flex-shrink: 0;
      width: 55px;
      height: 55px;
      margin: 0 12px;
      background-image: url("~@/assets/imgs/act/wc2026/footerBox.png");
    }
    .result-text {
      color: #fcffff;
      flex: 1;
    }
  }

  // 队伍对战区
  .match-teams {
    display: flex;
    justify-content: center;

    margin-bottom: 20px;

    .team {
      .team-flag {
        width: 178px;
        height: 114px;
        object-fit: cover;
      }

      .team-name {
        margin-top: 10px;
        font-size: 17px;
        color: #fcffff;
        text-align: center;
        /* 文字的外边框 */
        text-shadow: -2px 0 #002654, 2px 0 #002654, 0 -2px #002654,
          0 2px #002654;
      }
    }

    .vs-block {
      width: 138px;
      height: 120px;
      margin: 0 40px;
      background-image: url("~@/assets/imgs/act/wc2026/match/vs.png");
    }
  }

  // 底部操作区
  .match-action {
    padding: 28px;
    justify-content: space-between;
    .cheer-btn-wrap {
      position: relative;
      width: 261px;
      height: 98px;
      background-image: url("~@/assets/imgs/act/wc2026/match/cheer-bg.png");

      font-size: 22px;
      color: #fcffff;
      /* 文字的外边框 */
      text-shadow: -2px 0 #002654, 2px 0 #002654, 0 -2px #002654, 0 2px #002654;
      .cheered-icon {
        position: absolute;
        display: none;
        top: -27px;
        right: -22px;
        width: 83px;
        height: 63px;
        background-image: url("~@/assets/imgs/act/wc2026/match/cheered-icon.png");
      }
      &.cheered {
        width: 268px;
        height: 104px;
        background-image: url("~@/assets/imgs/act/wc2026/match/cheered-bg.png");
        .cheered-icon {
          display: block;
        }
      }
    }

    .cheer-result-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 20px;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 10px;

      .cheer-for-label {
        font-size: 22px;
        color: rgba(255, 255, 255, 0.5);

        strong {
          color: #e0e6f0;
        }
      }

      .cheer-settle-tag {
        font-size: 20px;
        padding: 6px 18px;
        border-radius: 20px;

        &.pending {
          background: rgba(255, 255, 255, 0.08);
          color: rgba(255, 255, 255, 0.4);
        }

        &.win {
          background: rgba(76, 175, 80, 0.15);
          color: #4caf50;
          border: 1px solid rgba(76, 175, 80, 0.35);
        }

        &.lose {
          background: rgba(244, 67, 54, 0.1);
          color: #ef9a9a;
        }

        &.cancelled {
          background: rgba(255, 193, 7, 0.1);
          color: #ffc107;
        }
      }
    }
  }
}

// 应援按钮覆盖 shared.less 中的按钮颜色
.wc-btn {
  &.primary {
    background: #4caf50;
    color: #fff;
    &:hover {
      background: #43a047;
    }
    &:disabled {
      background: rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.3);
      cursor: not-allowed;
    }
  }

  &.secondary {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.15);
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

.empty-tip {
  text-align: center;
  color: rgba(255, 255, 255, 0.3);
  padding: 60px 0;
  font-size: 24px;
}

.match-time-text {
  font-size: 20px;
  color: #fcffff;
  text-align: center;
  padding: 8px;
  text-shadow: -2px 0 #002654, 2px 0 #002654, 0 -2px #002654, 0 2px #002654;
}
</style>
